import { ElementRef, Injectable, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SmaPortalService implements OnDestroy {
  private readonly _hostElement$ = new ReplaySubject<ElementRef>(1);

  get hostPortal$(): Observable<ElementRef> {
    return this._hostElement$.asObservable();
  }

  setHostPortal(el: ElementRef): void {
    this._hostElement$.next(el);
  }

  ngOnDestroy(): void {
    this._hostElement$.complete();
  }
}
